import { Form, Formik } from "formik";
import React from "react";
import * as Yup from "yup";
import MyTextInput from "../../app/common/form/MyTextInput";
import { Button } from "@chakra-ui/button";

import { resetPassword } from "../../app/firestore/firebaseService";

import { HStack, Stack, StackDivider } from "@chakra-ui/layout";
import { FormControl, FormLabel } from "@chakra-ui/form-control";
import { useHistory } from "react-router";
import { useToast } from "@chakra-ui/toast";

export default function RecoverPasswordForm() {
  // const dispatch = useDispatch();
  const history = useHistory();
  const toast = useToast();

  function handleCancel() {
    // dispatch(closeModal());
    if (history) {
      history.push("/login");
    }
  }

  return (
    // <ModalWrapper size='mini' header='Register'>
    <Formik
      initialValues={{ email: "" }}
      validationSchema={Yup.object({
        email: Yup.string().required().email(),
      })}
      onSubmit={async (values, { setSubmitting, setErrors }) => {
        try {
          await resetPassword(values);

          setSubmitting(false);

          toast({
            title: "EMail sent!",
            description: "Check your mailbox and reset your password.",
            status: "success",
            isClosable: true,
          });
          if (history) {
            history.push("/login");
          }
        } catch (error) {
          setErrors({ auth: error.message });
          setSubmitting(false);
        }
      }}
    >
      {({ isSubmitting, isValid, dirty, errors }) => (
        <HStack>
          <Stack>
            <Form>
              <FormControl>
                <Stack spacing={5}>
                  <MyTextInput name='email' label='eMail' />

                  {errors.auth && (
                    <FormLabel
                      basic
                      color='red'
                      style={{ marginBottom: 10, top: "53px" }}
                    >
                      {errors.auth}
                    </FormLabel>
                  )}
                  <StackDivider />
                  <HStack>
                    <Button
                      isLoading={isSubmitting}
                      isDisabled={!isValid || !dirty || isSubmitting}
                      type='submit'
                      variant='primary'
                      id='id_submit'
                      w={400}
                    >
                      Reset Password
                    </Button>
                    <Button onClick={handleCancel} variant='outline' w={100}>
                      Cancel
                    </Button>
                  </HStack>
                </Stack>
              </FormControl>
            </Form>
          </Stack>
        </HStack>
      )}
    </Formik>
    // {/* </ModalWrapper> */}
  );
}
